import SpecialCandidateDestination from 'entities/user_notice/special_destination_candidate'
import PropTypes from 'prop-types'
import React from 'react'

const SelectionSummary = ({ className, recruiterIds, tagIds, specialTypes, specials }) => {
  if (recruiterIds.length > 0) {
    return (
      <span className={className}>
        {I18n.t('components.destinations_field.selection_summary.selected_recruiters', { num: recruiterIds.length })}
      </span>
    )
  }

  if (tagIds.length > 0) {
    return (
      <span className={className}>
        {I18n.t('components.destinations_field.selection_summary.selected_tags', { num: tagIds.length })}
      </span>
    )
  }

  if (specialTypes.length > 0) {
    const special = specials.find(s => s.type === specialTypes[0])
    if (!special) {
      return (
        <span className={className}>
          {I18n.t('components.destinations_field.selection_summary.selected_destinations', {
            num: specialTypes.length
          })}
        </span>
      )
    }

    return (
      <span className={className}>
        {specialTypes.length === 1
          ? I18n.t('components.destinations_field.selection_summary.selected_special', { name: special.name })
          : I18n.t('components.destinations_field.selection_summary.selected_special', {
              name: special.name,
              num: specialTypes.length - 1
            })}
      </span>
    )
  }

  return <span className={className}>{I18n.t('components.destinations_field.selection_summary.unset')}</span>
}

SelectionSummary.propTypes = {
  className: PropTypes.string,
  recruiterIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  tagIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  specialTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  specials: PropTypes.arrayOf(PropTypes.instanceOf(SpecialCandidateDestination)).isRequired
}

SelectionSummary.defaultProps = {
  className: null
}

export default SelectionSummary
